import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import JeaCard from "@/components/jea/JeaCard";
import Skeleton from "@/components/jea/Skeleton";
import JeaButton from "@/components/jea/JeaButton";
import { demoClient, useDemo } from "@/pages/demo/DemoShell";
import { formatMoney, formatDate } from "@/lib/pricing";

const DemoDebtorsPage = () => {
  const [debtors, setDebtors] = useState([]);
  const [loading, setLoading] = useState(true);
  const demo = useDemo();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await demoClient.get("/demo/debtors");
        setDebtors(data.debtors || []);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="space-y-6" data-testid="demo-debtors">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="text-[28px] font-bold text-white">Judgments</h1>
        <JeaButton onClick={() => demo?.openSignUp("adding judgments")} className="gap-2" data-testid="demo-debtors-add">
          <Plus size={14} /> Add New Judgment
        </JeaButton>
      </div>
      <JeaCard className="p-0">
        {loading ? <Skeleton className="h-40" /> : (
          <table className="w-full" data-testid="demo-debtors-table">
            <thead>
              <tr className="border-b border-border-default">
                {["Debtor Name", "Tier", "Case Number", "State", "Judgment", "Actions"].map((h) => (
                  <th key={h} className="jea-caption text-text-secondary p-4 text-left">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {debtors.map((d) => (
                <tr key={d.id} className="border-b border-border-default hover:bg-bg-tertiary transition-colors">
                  <td className="p-4">
                    <Link to={`/demo/debtors/${d.id}`} className="text-white font-semibold hover:text-accent-pink">
                      {d.full_name}
                    </Link>
                  </td>
                  <td className="p-4 uppercase text-[11px] tracking-[0.06em] font-bold text-text-secondary">{d.tier}</td>
                  <td className="p-4 jea-mono text-text-secondary">{d.judgment?.case_number || "—"}</td>
                  <td className="p-4 text-text-secondary">{d.judgment?.state || "—"}</td>
                  <td className="p-4 jea-mono text-accent-pink font-bold">
                    {formatMoney(d.judgment?.amount_cents || 0)}
                  </td>
                  <td className="p-4">
                    <button
                      onClick={() => demo?.openSignUp("running queries")}
                      className="text-accent-pink text-[12px] font-semibold hover:text-accent-pink-light"
                      data-testid={`demo-debtors-run-${d.id}`}
                    >
                      Run Query
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </JeaCard>
    </div>
  );
};

export default DemoDebtorsPage;
